import { render, staticRenderFns } from "./Report2ImageCaption.vue?vue&type=template&id=4c7cdbf0&scoped=true&"
import script from "./Report2ImageCaption.vue?vue&type=script&lang=js&"
export * from "./Report2ImageCaption.vue?vue&type=script&lang=js&"
import style0 from "./Report2ImageCaption.vue?vue&type=style&index=0&id=4c7cdbf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7cdbf0",
  null
  
)

export default component.exports